import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next";

const useStyles= makeStyles({
    coverEntireScreen:{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        left:"0",
        top:"0",
        width:"100vw",
        height:"100vh",
        background:"white",
        color:"#000000"
    },
    flexbox1:{
        display:"flex",
        flexDirection:"column",
        alignItems:"center",
        justifyContent:"center",
        color:"#707070",
        "& img":{
            height:"181px",
            width:"350px",
        },
        "& strong":{
            font: "normal normal 600 20px/16px Open Sans",
            color: "#000000D9",
            margin:"5px"
        },
        "& span":{
            font: "normal normal 600 16px/16px Open Sans",
            color: "#707070",
            margin:"5px"
        }
    }
});

function InvalidAuthentication(){
    const classes=useStyles();
    const { t } = useTranslation(['styles', 'translation']);

    return (
        <>
        <div className={classes.coverEntireScreen}>
            <div className={classes.flexbox1}>
                <img src={require("../../../Icons/AutheticationError.svg").default} alt="errorImage" />
                <strong> {t(`translation:${"An error has occurred"}`)}   </strong>
                <span> {t(`translation:${"Invalid Authentication."}`)} </span>
            </div>
        </div>
        </>
    )
}

export default InvalidAuthentication